import React from 'react';
import './Configuracion.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ConfigData from '../../Components/Admin/ConfigData/ConfigData';

export default function Configuracion() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container configuracion-container-custom'>
                    <ConfigData />
                </div>
            </section>
        </div>
    );
}

